// Customer-facing presentation of the verified market and bot state. The
// rotating lines describe watch mode, never an unrecorded strategy evaluation.
const WATCH_MESSAGES = Object.freeze([
  'Scanning the market for opportunities…',
  'Watching price movements…',
  'Monitoring your selected stocks…',
  'Looking for strategy opportunities…',
  'Standing by for the next check…',
]);

const READY_MESSAGES = Object.freeze([
  'Checking the market schedule…',
  'Getting ready to watch…',
  'Standing by for the opening bell…',
]);

const staticView = (state, title, summary, robot = state) => ({
  state, title, summary, robot, motion: false, line: false, messages: [],
});

export const marketPresence = (presence, bot) => {
  switch (presence.kind) {
    case 'sleeping':
      return { ...staticView('sleeping', 'Market Closed', 'The bot is waiting for the next eligible market session.'), motion: true };
    case 'waking':
      return { state: 'waking', title: 'Pre-Market · Getting Ready',
        summary: 'Warming up for the next market session.', robot: 'waking',
        motion: true, line: true, messages: READY_MESSAGES };
    case 'preparing':
      return { state: 'waking', title: 'Getting ready',
        summary: presence.motion ? 'Market-data preparation is active.' : 'Preparation was requested; current activity is unconfirmed.',
        robot: 'preparing', motion: presence.motion, line: presence.motion,
        messages: presence.motion ? READY_MESSAGES : [] };
    case 'monitoring':
    case 'working':
      return { state: 'watching',
        title: bot?.market?.phase === 'mixed' ? 'Watching market sessions'
          : bot?.market?.phase === 'open' ? 'Market Open · Working' : 'Watching a verified check',
        summary: presence.kind === 'working' ? 'A strategy check is in progress.'
          : bot?.market?.phase === 'open' ? 'Analysing the market for potential opportunities.'
            : 'On watch for the next opportunity.',
        robot: presence.kind, motion: true, line: true, messages: WATCH_MESSAGES };
    case 'evaluation_started':
      return staticView('standby', 'Check started', 'Continued work is not yet confirmed.', 'evaluation_started');
    case 'standby':
      return { ...staticView('standby', 'Ready and waiting', 'Market hours are unavailable.'), motion: true };
    case 'paused':
      return staticView('paused', 'Taking a break', 'Practice checks are paused.');
    case 'fault':
      return staticView('attention', 'Needs attention', 'Review the bot report for the recorded problem.', 'fault');
    case 'offline':
      return staticView('attention', 'Update unavailable', 'A fresh worker update is not available.', 'offline');
    case 'archived':
      return staticView('inactive', 'Archived', 'This bot is no longer active.', 'archived');
    case 'inactive':
      return staticView('inactive', 'Not watching yet', 'Start this bot when you are ready.', 'inactive');
    default:
      return staticView('unavailable', 'Activity unavailable', 'Pinngro cannot confirm this bot’s status.', 'unavailable');
  }
};
